<template>
  <div class="card">
    <header class="header-card">
      <p>{{ $t('detailOrdreTravailTech.caracterique.infoGenerale.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-3">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoGenerale.dateSouhaite')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ ordreTravail.dateSouhaitee | formatDate }}
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoGenerale.dateRealisation')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ ordreTravail.dateRealisation | formatDate }}
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoGenerale.datePlanification')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ ordreTravail.datePlanification | formatDate }}
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoGenerale.dateFacture')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ ordreTravail.dateFacture | formatDate }}
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoGenerale.typeIntervention')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold" >
              <router-link-blank
                :to="{ name: 'c.logistique.type_ot', params: { id: ordreTravail.typeOtId }}"
                class="lien"
                :message="getLibelleTypeIntervention">
              </router-link-blank>
            </span>
            <span>
              <b-icon icon="warehouse" class="mgr-5px mgl-5px" v-if="isImpressionAfficheWithStock"
                  size="is-small"
                  type="is-success">
                </b-icon>
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoGenerale.technicien')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              <router-link-blank v-if="ordreTravail.fournisseur"
                :to="{ name: 'c.logistique.technicien', params: { id: ordreTravail.fournisseurId,
                 sousTypeFrom: technicien }}"
                class="lien"
                :message="ordreTravail.fournisseur ? ordreTravail.fournisseur.nomCommercial : null">
              </router-link-blank>
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoGenerale.montantHT')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ ordreTravail.montantHt | formatDevise }}
            </span>
          </b-field>
        </div>
        <div class="column is-3" v-if="agencesSelectionnees.length > 1">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoGenerale.agence')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ getLibelleAgence }}
            </span>
          </b-field>
        </div>
        <div class="column is-2" v-if="afficherProjetDossier">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoGenerale.projet')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
              <router-link-blank v-if="ordreTravail.dossierLogistiqueTechniqueId"
                :to="{ name: 'm.logistique.projets', params: {
                  id: ordreTravail.dossierLogistiqueTechnique.projet.id }}"
                class="lien"
                :message="ordreTravail.dossierLogistiqueTechnique
                ? ordreTravail.dossierLogistiqueTechnique.projet.libelle : null">
              </router-link-blank>
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoGenerale.codeFacture')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ ordreTravail.codeFacture }}
            </span>
          </b-field>
        </div>
        <div class="column is-3"
          v-if="isOTImpression">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoGenerale.lieuDeStockage')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <router-link-blank v-if="ordreTravail.otStock.lieuDeStockage"
              classMessage="has-text-weight-bold lien mgr-5px"
              :to="{ name: 'c.bodac.clients/contacts-client',
                params: {id: ordreTravail.otStock.lieuDeStockageId}}"
              :message="ordreTravail.otStock.lieuDeStockage.nomCommercial"/>
          </b-field>
        </div>
        <div
          v-if="ordreTravail.bonExpeditionId"
          class="column is-3">
          <b-field
            :label="$t('detailOrdreTravailTech.caracterique.infoGenerale.bonExpedition')"
            custom-class="has-text-weight-normal is-italic is-marginless">
            <router-link-blank
              classMessage="has-text-weight-bold lien mgr-5px"
              :to="{name: 'c.logistique.bon_expedition', params:{id: ordreTravail.bonExpeditionId}}"
              :message="func.formatDate(ordreTravail.dateBonExpedition)"/>
          </b-field>
        </div>
        <div :class="ordreTravail.bonExpeditionId ? 'column is-6' : 'column is-9'">
          <b-field
            :label="$t('detailOrdreTravailTech.caracterique.infoGenerale.description')"
            custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ ordreTravail.description }}
            </span>
          </b-field>
        </div>
        <div v-if="isTypeOtImpressionAffiche" class="column is-12">
          <b-field
            :label="$t('detailOrdreTravailTech.caracterique.infoGenerale.tags')"
            custom-class="has-text-weight-normal is-italic is-marginless">
            <query-tags-tag-input class="mgt-2px"
              :value="ordreTravailTags"
              field="tag"
              is-detail>
            </query-tags-tag-input>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import QueryTagsTagInput from '@/components/general/tagInput/queryTagsTagInput';
import { TIERS_SOUS_TYPE_TECHNICIEN } from '@/configuration/tiers/tiersConf';
import { IMPRESSION_AFFICHE } from '@/configuration/logistique/typeOt/typeOtConfig';
import formatDate from '@/services/general/formatDate';

const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    ordreTravail: {
      type: Object,
      required: true,
    },
    isOTImpression: {
      type: Boolean,
    },
  },
  data() {
    return {
      technicien: TIERS_SOUS_TYPE_TECHNICIEN,
      bonStock: null,
      func: { formatDate },
    };
  },
  components: {
    routerLinkBlank,
    QueryTagsTagInput,
  },
  computed: {
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    typesOT() {
      return this.parametre(PARAMETRES_KEYS.typeOt);
    },
    getLibelleAgence() {
      const agenceFind = this.user.agences.find((agence) => {
        return agence.agenceId === this.ordreTravail.agenceId;
      });
      if (agenceFind) return agenceFind.libelleAgence;
      return '';
    },
    getLibelleTypeIntervention() {
      return this.ordreTravail.typeOt.libelle;
    },
    afficherProjetDossier() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.afficherProjetDossierLogistiqueTechnique
        .key);
    },
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    isImpressionAfficheWithStock() {
      return this.ordreTravail.typeOt?.actionInterventionOt === IMPRESSION_AFFICHE
      && this.ordreTravail.typeOt?.produit?.stockable
      && this.moduleStockTiersActive;
    },
    bonStockId() {
      return this.bonStock?.id;
    },
    isTypeOtImpressionAffiche() {
      const typeOt = this.typesOT.find(typeOT => typeOT.id === this.ordreTravail.typeOtId);
      return typeOt?.actionInterventionOt === IMPRESSION_AFFICHE;
    },
    ordreTravailTags() {
      const { tags: otTags } = this.ordreTravail;
      return otTags.map((otTag) => ({
        ...otTag,
        tag: this.parametre(PARAMETRES_KEYS.tag).find((tag) => tag.id === otTag.tagId),
      }));
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.typeOt, PARAMETRES_KEYS.tag]);
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.afficherProjetDossierLogistiqueTechnique.key,
        PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
      ]);
      if (this.ordreTravail.otStock) {
        this.bonStock = { id: this.ordreTravail.otStock.bonStockId };
      }
      const typeFind = this.typesOT.find((type) => {
        return type.id === this.ordreTravail.typeOtId;
      });
      this.ordreTravail.typeOt = typeFind;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};

</script>
